// @ts-ignore
import styles from './TimelineGridLegend.module.scss';
import { ITimelineGridLegendItem } from '../../Models/TimelineGrid/ITimelineGridLegendItem';

export default function TimelineGridLegendItem(props: ITimelineGridLegendItem) {
	const { title, color } = props;

	const handleClick = () => {
		console.log('Clicked at legend item');
		return [];
	};

	return (
		<div className={styles.item} onClick={handleClick()}>
			<div className={styles.bubble} style={{ backgroundColor: color }} />
			<div className={styles.itemTitle}>{title}</div>
		</div>
	);
}
